// @flow
/* istanbul ignore file */

import WebAnalytics from '@icis/code/modules/WebAnalytics';
import logger from '../utils/logger';
import getAppConfig from '../constants/getAppConfig';
import formatLanguageString from '../utils/formatLanguageString';

const appConfig = getAppConfig();

export const webAnalytics = new WebAnalytics({
  logger,
  analyticsScriptSrc: appConfig.urls.analyticsScript,
  getDefaultTrackingData: () => {
    const locale = '';
    const userId = '';
    return {
      gwa_account: appConfig.analytics.account,
      gwa_siteSection1: 'subscriber',
      gwa_siteSection2: 'website',
      gwa_server: 'website',
      gwa_localVar22: formatLanguageString(locale),
      gwa_userID: userId,
    };
  },
});

export const { loadAnalytics, trackPageView, trackAction } = webAnalytics;
